import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { PayablesAbout } from "@/components/payment/payables/payables-about";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";

import type { JSX } from "react";

const AboutPayablesPage = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderButton align="start" icon={Left} />
        <HeaderTitle title="Sobre" align="center" />
      </HeaderRoot>
      <Page>
        <PayablesAbout />
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/payments/payables/about")({
  component: AboutPayablesPage,
});
